import React, { useEffect, useMemo } from "react";
import { useForm, useFormState } from "react-final-form";
import { useSelector } from "react-redux";
import Input from "rs-components/Input";
import SelectInput from "rs-components/Input/components/SelectInput";
import SelectItemRenderer from "rs-components/Input/components/SelectInput/components/SelectItemRenderer";
import { FormField } from "../../../../index";
import { getInsightInputOptionsSelector } from "store/rs-workspace/selectors/rs-workspace.selectors";
import * as styles from "../../../../styles.module.scss";
const InsightInputSelect = ({ restrictions }) => {
    const form = useForm();
    const formState = useFormState();
    const { insightId, inputSetId } = useMemo(() => ({ ...formState.values }), [formState.values]);
    const options = useSelector(getInsightInputOptionsSelector(insightId, inputSetId));
    const selectedValue = useMemo(() => options.find(({ value }) => value === inputSetId), [inputSetId, options]);
    useEffect(() => {
        if (!inputSetId && options[0]) {
            form.change(FormField.INPUT_SET_ID, options[0]?.value);
            form.blur(FormField.INPUT_SET_ID);
        }
        else if (inputSetId && !options.find(({ value }) => value === inputSetId)) {
            form.change(FormField.INPUT_SET_ID, options[0]?.value);
            form.blur(FormField.INPUT_SET_ID);
        }
    }, [form, inputSetId, options]);
    return (React.createElement("div", { className: styles.field },
        React.createElement(Input, { component: SelectInput, name: FormField.INPUT_SET_ID, label: "Use data from", items: options, value: selectedValue, valueFormatter: ({ value }) => value, itemRenderer: SelectItemRenderer, classes: { component: styles.selectWrapper, label: styles["field-label"] }, restrictions: restrictions })));
};
export default InsightInputSelect;
